import React, { useContext } from "react";
import pattern1 from "../../../assets/pattern1.png";
import { fontstyle1, fontstyle3 } from "../../../utils/fonts";
import ThemeContext from "../../../context";
import ColorsTheme from "../../../utils/colors";
import instance from "../../../utils/axios";

const Contactform = () => {
  const { theme } = useContext(ThemeContext);
  const colortheme = ColorsTheme[theme];

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      uid: "629806763d7a2ab4d55a1f8e",
      pid: "2r1uk7n62U-feedback-form",
      username: document.getElementById("dfin_username").value,
      email: document.getElementById("dfin_email").value,
      feedback1: document.getElementById("dfin_feed1").value
    };

    instance
      .post("/Feedback", data)
      .then((res) => {
        document.getElementById("dfin_username").value = "";
        document.getElementById("dfin_email").value = "";
        document.getElementById("dfin_feed1").value =
          "Thanks for your feedback";
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div
      className={`${
        theme === "light" ? "bg-white" : colortheme.background
      } h-full flex items-center justify-center mt-10 sm:mt-20`}
    >
      <div
        className=" flex items-center justify-between container"
        style={fontstyle1}
      >
        <form id="contact" className=" font-bold" onSubmit={handleSubmit}>
          <h1 className="text-4xl  mb-6">Contact Us</h1>
          <div
            className={`w-full sm:w-96 ${
              theme === "light" ? "text-gray-800" : colortheme.color
            }`}
          >
            <div className="flex flex-col">
              <label className=" text-sm font-semibold leading-tight tracking-normal mb-2">
                User Name
              </label>
              <input
                required
                id="dfin_username"
                name="user_name"
                type="text"
                className="focus:outline-none focus:border focus:border-indigo-700 font-normal w-64 h-10 flex items-center pl-3 text-sm border-gray-300 rounded border text-black"
                placeholder="User Name"
                style={fontstyle3}
              />
            </div>
            <div className="flex flex-col">
              <label className=" text-sm font-semibold leading-tight tracking-normal mb-2 mt-2">
                Email
              </label>
              <input
                required
                id="dfin_email"
                name="email"
                type="email"
                className="focus:outline-none focus:border focus:border-indigo-700 font-normal w-64 h-10 flex items-center pl-3 text-sm border-gray-300 rounded border text-black"
                placeholder="Email"
                style={fontstyle3}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-sm font-semibold  mb-2 mt-2">
                Feedback
              </label>
              <textarea
                name="message"
                className="border-gray-300 border mb-4 rounded py-2 text-sm outline-none resize-none px-3 focus:border focus:border-indigo-700 text-black"
                rows={8}
                id="dfin_feed1"
                placeholder="Feedback"
                defaultValue={""}
                style={fontstyle3}
                required
              />
            </div>
            <button
              type="submit"
              className="p-2 bg-[#FF834F] text-white rounded pl-5 pr-5 cursor-pointer flex items-center gap-3"
              style={fontstyle1}
            >
              Submit
            </button>
          </div>
        </form>
        <div className="hidden sm:block">
          <img src={pattern1} alt="pattern" className="w-80" />
        </div>
      </div>
    </div>
  );
};

export default Contactform;
